var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNeon = function SvgNeon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32C0ED",
    fillRule: "evenodd",
    d: "M0 4.828A4.834 4.834 0 0 1 4.843 0h18.405c2.675 0 4.844 2.161 4.844 4.828V20.43c0 2.758-3.502 3.955-5.2 1.778l-5.31-6.809v8.256c0 2.4-1.952 4.345-4.36 4.345H4.843A4.835 4.835 0 0 1 0 23.172zm4.843-.966a.967.967 0 0 0-.968.966v18.344c0 .534.433.966.968.966h8.525c.267 0 .339-.216.339-.483v-11.07c0-2.76 3.502-3.956 5.2-1.779l5.31 6.809V4.828c0-.534.05-.966-.484-.966z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#neon_svg__a)",
    fillRule: "evenodd",
    d: "M0 4.828A4.834 4.834 0 0 1 4.843 0h18.405c2.675 0 4.844 2.161 4.844 4.828V20.43c0 2.758-3.502 3.955-5.2 1.778l-5.31-6.809v8.256c0 2.4-1.952 4.345-4.36 4.345H4.843A4.835 4.835 0 0 1 0 23.172zm4.843-.966a.967.967 0 0 0-.968.966v18.344c0 .534.433.966.968.966h8.525c.267 0 .339-.216.339-.483v-11.07c0-2.76 3.502-3.956 5.2-1.779l5.31 6.809V4.828c0-.534.05-.966-.484-.966z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#neon_svg__b)",
    fillOpacity: 0.4,
    fillRule: "evenodd",
    d: "M0 4.828A4.834 4.834 0 0 1 4.843 0h18.405c2.675 0 4.844 2.161 4.844 4.828V20.43c0 2.758-3.502 3.955-5.2 1.778l-5.31-6.809v8.256c0 2.4-1.952 4.345-4.36 4.345H4.843A4.835 4.835 0 0 1 0 23.172zm4.843-.966a.967.967 0 0 0-.968.966v18.344c0 .534.433.966.968.966h8.525c.267 0 .339-.216.339-.483v-11.07c0-2.76 3.502-3.956 5.2-1.779l5.31 6.809V4.828c0-.534.05-.966-.484-.966z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#63F655",
    d: "M23.248 0a4.835 4.835 0 0 1 4.843 4.828V20.43c0 2.758-3.502 3.955-5.2 1.778l-5.31-6.809v8.256c0 2.4-1.951 4.345-4.359 4.345a.483.483 0 0 0 .485-.483V12.584c0-2.758 3.501-3.955 5.2-1.777l5.31 6.808V.965A.967.967 0 0 0 23.248 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M48.17 7.432v8.032l-7.346-8.032H37v13.136h3.487v-8.632l8.002 8.632h3.169V7.432zm9.953 10.208v-2.326h7.807v-2.797h-7.807V10.36h9.47V7.432H54.565v13.136h13.224v-2.927zM77.056 21c4.903 0 8.09-2.552 8.09-7s-3.187-7-8.09-7-8.073 2.552-8.073 7 3.169 7 8.073 7m0-3.115c-2.727 0-4.408-1.408-4.408-3.885s1.7-3.885 4.408-3.885c2.726 0 4.408 1.408 4.408 3.885s-1.682 3.885-4.408 3.885M98.513 7.432v8.032l-7.347-8.032h-3.824v13.136h3.488v-8.632l8.001 8.632H102V7.432z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon_svg__a",
    x1: 28.092,
    x2: 3.481,
    y1: 28,
    y2: -0.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EF51C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EF51C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "neon_svg__b",
    x1: 28.092,
    x2: 11.421,
    y1: 28,
    y2: 21.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A",
    stopOpacity: 0
  })))));
};
export default SvgNeon;